// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`Paso2 test Match con el snapshot 1`] = `""`;
